"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
exports.path = '/service-center-gateway-remove';
//# sourceMappingURL=index.js.map